<app-license-add
  [userObject]="userObject"
  [dialogRef]="dialogRef"
>
</app-license-add>
